import { FormControl, FormHelperText, InputLabel, TextField } from '@material-ui/core';
import AutocompleteMUI from '@material-ui/lab/Autocomplete';
import { useField } from 'formik';
import React from 'react';
import { Hint } from 'v2/components/Shared/Hint';

import type { FieldProps } from 'formik';

interface ISelectOption {
  label: string;
  value: string | number;
  disabled?: boolean;
}

type AutoCompleteFormFieldProps = FieldProps & {
  label?: string;
  options: ISelectOption[];
  loading?: boolean;
  helperText?: React.ReactNode;
  placeholder?: string;
  isLoading?: boolean;
  value?: ISelectOption;
  disabled?: boolean;
};

export const AutoCompleteFormField = ({
  field,
  label,
  form,
  helperText: helperTextProp,
  isLoading,
  disabled,
  ...props
}: AutoCompleteFormFieldProps) => {
  const [, meta] = useField(field.name);
  const isError = meta.touched && !!meta.error;
  const helperText = isError ? meta.error : helperTextProp;

  const handleChange = React.useCallback(
    (e: any, option: any) => {
      field.onChange(e);
      form.setFieldValue(field.name, option);
    },
    [field, form]
  );

  return (
    <Hint inputName={field.name}>
      <FormControl fullWidth error={isError}>
        {label && <InputLabel style={{ paddingBottom: 8 }}>{label}</InputLabel>}
        <AutocompleteMUI
          size='small'
          getOptionLabel={(option: ISelectOption) => option.label}
          noOptionsText='Sem opções...'
          options={props.options}
          value={field.value}
          onChange={handleChange}
          renderInput={(params) => <TextField {...params} name={field.name} placeholder={props.placeholder} fullWidth variant='outlined' />}
          disabled={isLoading || disabled}
        />
        {isError && <FormHelperText>{meta.error}</FormHelperText>}
        {!isError && helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </Hint>
  );
};
